<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"></i>
          </div>
          <div>
            <h2 class="clean-section-title has-text-white has-text-weight-bold">
              خدمات البطاقة المحلية (تجوال)
            </h2>
            <h3 class="subtitle is-5 pt-20 has-text-white has-text-weight-bold">
              لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ، إعادة إصدار
              رقم سري.
            </h3>
          </div>
        </div>

        <div class="columns is-vcentered s">
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              @click="makeRequest(' إصدار بطاقة', 5)"
            >
              <h3 class="card-title has-text-link">إصدار بطاقة</h3>
              <p class="card-description">
                يمكنك التقدم بطلب الحصول على بطاقة خصم مباشر محلية (تجوال) ،
                والتي تستخدم للسحب نقداً من أجهزة الصراف الآلي ، أو لدفع المبالغ
                إلكترونيا مقابل عمليات الشراء.
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              @click="makeCardRequest('تغير الرقم السري', 6)"
            >
              <h3 class="card-title has-text-link is-clean">
                إعادة إصدار رقم سري
              </h3>
              <p class="card-description">
                في حال فقدان الرقم السري بسبب نسيانه أوتلفه ، فإنه يمكنكم إصدار
                رقم سري جديد وطباعته والذي بدوركم زيارة فرعكم المصرفي لإستلامه .
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              @click="makeCardRequest('تفعيل البطاقة', 7)"
            >
              <h3 class="card-title has-text-link is-clean">تفعيل البطاقة</h3>
              <p class="card-description">
                نظراً لتعذر الاستفادة من بطاقتك بسبب توقفها عن الخدمة لسببٍ ما ،
                فإنه يمكنك الإخطار عن توقفها للنظر في إعادة تفعيلها مجدداً ، ما
                لم يتم إتلافها .
              </p>
            </div>
          </div>
        </div>

        <div class="columns is-vcentered">
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              @click="makeCardRequest('تعطيل البطاقة', 8)"
            >
              <h3 class="card-title has-text-link is-clean">إيقاف البطاقة</h3>
              <p class="card-description">
                عند رغبتك في العمل على ايقاف بطاقتك عن الخدمة بسبب فقدانها أو
                لأي سبب آخر ، فإنه يمكنك إيقافها عن الخدمة ، وإعادة تفعيلها
                لاحقاً .
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              @click="makeCardRequest(' إصدار بطاقة بدل فاقد', 35)"
            >
              <h3 class="card-title has-text-link">إصدار بطاقة بدل فاقد</h3>
              <p class="card-description">
                في حال فقدان البطاقة أوتلفه ، فإنه يمكنكم إصدار بطاقة أخرى بديلة
                ، والتي يتطلب منكم زيارة فرعكم المصرفي لإستلامه
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
      >
        <router-link to="/portal">
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
            <b>عودة للرئيسية</b>
          </a>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "alzaad",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "zad/newRequest",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: 108,
      },
    };
  },
  methods: {
    makeRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequest",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
    makeCardRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequestwithcard",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
  },
};
</script>
